export default "__VITE_ASSET__CeoDQ$DL__"